import {Expressions} from '@packages/systems/wfdl';
import type {ExpressionElement} from '@packages/systems/wfdl-ast';
import {EXPERIENCES_BY_VARIATION_ID} from './constants';

export function getExperienceIds(baseElement: ExpressionElement) {
  const result = new Set<string>();
  const experiencesByVariationId = Expressions.getIn(
    Expressions.getElementData(baseElement),
    EXPERIENCES_BY_VARIATION_ID
  );

  if (!experiencesByVariationId) {
    return result;
  }

  const experiencesByVariationIdRecord = Expressions.getRecord(
    experiencesByVariationId
  );

  if (!experiencesByVariationIdRecord) {
    return result;
  }

  for (const textExpression of Object.values(experiencesByVariationIdRecord)) {
    const experienceId = Expressions.getText(textExpression);
    if (experienceId) {
      result.add(experienceId);
    }
  }

  return result;
}
